<template>
  <div class="feedback" role="dialog">
    <div class="feedback__form-wrapper">
      <div class="feedback__close-btn-wrapper">
        <button @click="closeModal()" class="feedback__close-btn">
          Close <CloseBtn class="feedback__close-btn--icon" />
        </button>
      </div>
      <div class="feedback__content-wrapper">
        <div
          class="feedback__course-details"
          :style="
            `background-image: url(${$getCourseBackground(
              course.id,
              'large'
            )}), linear-gradient(${$getGradient()})`
          "
        >
          <div class="feedback__branding-wrapper">
            <h6 v-if="course.vendor" class="feedback__branding">
              {{ course.vendor.name }}
            </h6>
            <h6 v-else class="feedback__branding">
              INE
            </h6>
            <h4 itemprop="courseCode" class="feedback__title content-title">
              {{ course.name }}
            </h4>
          </div>
        </div>
        <div class="feedback__thankyou" v-if="feedbackSubmitted">
          <div class="feedback__thankyou-wrapper">
            <h4 class="feedback__thankyou-text">
              Thank you for providing feedback!
            </h4>
            <div class="feedback__thankyou-comment">
              We’re continually working<br />
              to improve your experience.
            </div>
          </div>
        </div>
        <div class="feedback__form-wrapper" v-else>
          <FeedbackForm
            :course="course"
            :rating="rating"
            @feedback-submitted="feedbackSubmitted = true"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CloseBtn from '@/assets/icons/navigation/INE_close.svg'
import FeedbackForm from '@/components/forms/FeedbackForm.vue'

export default {
  name: 'FeedbackModal',
  components: {
    CloseBtn: { ...CloseBtn, name: 'CloseBtn' },
    FeedbackForm,
  },
  data: () => {
    return {
      feedbackSubmitted: false,
    }
  },
  computed: {
    ...mapState({
      course: state => state.courses.currentCourse,
      rating: state => state.courses.courseRating,
    }),
  },
  methods: {
    closeModal() {
      this.$emit('close-modal', true)
    },
  },
  created() {
    const body = document.querySelector('body')
    body.classList.add('modal-open')
  },
  destroyed() {
    const body = document.querySelector('body')
    body.classList.remove('modal-open')
  },
}
</script>

<style lang="scss" scoped>
.feedback {
  $this: &;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgba(21, 21, 21, 0.8);
  z-index: 9999;
  &__form-wrapper {
    padding: 0 5px 5px 5px;
    position: relative;
    overflow-y: scroll;
    @include tablet {
      overflow-y: auto;
      max-width: 720px;
    }
    @include desktop {
      overflow-y: auto;
      max-width: 1400px;
    }
  }
  &__close-btn-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    padding: 10px 0 10px;
  }
  &__close-btn {
    display: flex;
    align-items: center;
    color: var(--white);
    font-size: 1rem;
    background-color: transparent;
    border: none;
    transition: 0.3s all ease;
    text-decoration: underline;
    &:hover {
      cursor: pointer;
      color: var(--orange);
      #{$this}__close-btn--icon {
        fill: var(--orange);
      }
    }
    &--icon {
      fill: var(--white);
      height: 1rem;
      transition: 0.3s all ease;
      margin: 3px 5px 0 5px;
    }
  }
  &__course-details {
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    padding-left: 25px;
    padding-right: 40px;
    width: 100%;
    .feedback__branding {
      font-size: 12px;
      margin: 0;
    }
    .feedback__title {
      font-size: 1.7rem;
      line-height: 40px;
    }
    @include desktop {
      width: 45%;
      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 100%;
        height: 150%;
        width: 30%;
        background: var(--white);
        transform: rotate(5deg);
        transform-origin: 0 0;
      }
    }
  }
  &__content-wrapper {
    width: 100%;
    background: var(--white);
    display: flex;
    flex-wrap: wrap;
    text-align: left;
  }
  &__copy {
    color: var(--white);
    position: absolute;
    top: 10%;
    left: 70%;
    @include desktop {
      width: 50%;
      top: 50%;
      right: 25%;
      left: unset;
    }
  }
  &__thankyou {
    color: black;
    padding: 20px 20px;
    min-height: 60vh;
    display: flex;
    align-content: center;
    &-wrapper {
      display: flex;
      flex-wrap: wrap;
      align-content: center;
      align-items: center;
    }
    &-text {
      font-size: 28px;
      margin-top: 0;
      &::after {
        content: '';
        display: block;
        height: 1px;
        background: #b3b3b3;
        margin-top: 20px;
      }
    }
  }
  &__form-wrapper,
  &__thankyou {
    width: 100%;
    @include desktop {
      width: 55%;
    }
  }
}
</style>
